<nav aria-label="breadcrumbs" class="bolt-space-bottom-2xl">
    <is-bread-crumbs
        class="breadCrumbs"
        [homeIconLink]="homeIconLink"
        [breadCrumbs]="breadCrumbs"
        [currentPage]="currentPage"
        position="top"
        [isClaims]="true">
    </is-bread-crumbs>
</nav>

<main>
    <div class="bolt-container">
        <h1 class="bolt-heading-lg bolt-space-bottom-lg">Confirm repair shop</h1>
        @if (isLoading) {
            <bolt-waiting-indicator class="bolt-space-inner-xl" ></bolt-waiting-indicator>
        }
        @if (!isLoading) {
            <!-- Error message -->
            @if (errorMessage) {
                <div class="bolt-col-sm-12">
                    <bolt-notification type="error">
                        {{ errorMessage }}
                    </bolt-notification>
                </div>
            }

            <form [formGroup]="confirmForm">
                <!-- Vehicle Information -->
                @if (vehicleInfo) {
                    <div class="bolt-row bolt-space-bottom-md">
                        <div class="bolt-col-sm-12 bolt-heading-sm">{{ vehicleInfo.year }} {{ vehicleInfo.make }} {{ vehicleInfo.model }}</div>
                    </div>
                }

                <!-- Instructional text -->
                <div class="bolt-row bolt-space-bottom-lg">
                    <div class="bolt-col-sm-12">
                        <div class="bolt-body-copy-lg">
                            <img class="instructions-icon" src="assets/icons/people-manageparticipants-outline.svg"
                                alt=""
                                width="24"
                                height="24">
                            Here's the shop you selected. Click <strong>Submit</strong> and the shop will be in touch. To change to another shop, click <strong>Back</strong>.
                        </div>
                    </div>
                </div>

                <!-- Shop Details Card -->
                @if (selectedShop) {
                    <div class="bolt-row bolt-space-bottom-lg">
                        <div class="bolt-col-sm-12">
                            <div class="bolt-heading-sm bolt-space-bottom-xs">Details</div>
                            <div class="bolt-space-inner-wide-xl shop-container">
                                <div class="bolt-space-bottom-sm bolt-subheading-lg">
                                    <strong>{{ selectedShop.name || selectedShop.displayName || selectedShop.shopName || (selectedShop.city + ', ' + selectedShop.state) || 'Repair Shop' }}</strong>
                                </div>
                                <div class="bolt-space-bottom-sm">
                                    <a href="tel:{{ selectedShop.phoneNumber }}" class="bolt-link phone-link">{{ selectedShop.phoneNumber }}</a>
                                </div>
                                <div class="bolt-space-bottom-md bolt-body-copy-lg">
                                    {{ selectedShop.address }}<br>
                                    {{ selectedShop.city | titlecase }}, {{ selectedShop.state }} {{ selectedShop.zipCode }}<br>
                                </div>
                                <bolt-button
                                    iconleft="location"
                                    (click)="getDirections()"
                                    id="oysTrackerConfirm_directionsBtn">
                                    Get directions
                                </bolt-button>
                            </div>
                        </div>
                    </div>
                }

                <!-- Vehicle Location -->
                <div class="bolt-row bolt-space-bottom-lg nw-form-control">
                    <div class="bolt-col-sm-12">
                        <bolt-select
                            ngDefaultControl
                            formControlName="vehicleLocation"
                            id="vehicleLocation"
                            name="vehicleLocation"
                            label="Vehicle location"
                            required="true"
                            class="vehicle-location-select"
                            [error]="vehicleLocationError">
                            <option value="Home">Home</option>
                            <option value="Other">Other</option>
                            <option value="Unknown">Unknown</option>
                        </bolt-select>
                    </div>
                </div>

                <!-- Home Address Display -->
                @if (showHomeAddress && homeAddress) {
                    <div class="bolt-row bolt-space-bottom-lg">
                        <div class="bolt-col-sm-12">
                            <div class="bolt-body-copy-lg">
                                {{ homeAddress.addressLine1 }}<br>
                                {{ homeAddress.city | titlecase }}, {{ homeAddress.state }} {{ homeAddress.postalCode }}<br>
                                {{ homeAddress.country }}
                            </div>
                        </div>
                    </div>
                }

                @if (isOtherVehicleLocation) {
                    <div>
                        <is-vehicle-location-address-form (formValid)="onVehicleLocationFormValid($event)"></is-vehicle-location-address-form>
                    </div>
                }

                <!-- Towing Question -->
                @if (showTowingQuestion) {
                    <div class="bolt-row bolt-space-bottom-lg nw-form-control">
                        <div class="bolt-col-sm-12">
                            <bolt-radio-group
                                ngDefaultControl
                                [formControlName]="'towing'"
                                name="towing"
                                optionaltext="hide"
                                label="Do you need your vehicle towed to the repair facility?"
                                instructionaltext="If your vehicle is located more than 100 miles away, a claims professional may follow up with you."
                                [error]="towingError">
                                <bolt-contextual-help slot="help">
                                    <p>Your claims professional can assist you with contacting the facility to release your vehicle in order for it to be moved to the repair facility.</p>
                                </bolt-contextual-help>
                                <bolt-radio value="Yes">Yes</bolt-radio>
                                <bolt-radio value="No">No</bolt-radio>
                            </bolt-radio-group>
                        </div>
                    </div>
                }

                <!-- Towing Authorization Checkbox -->
                @if (showTowingAuth) {
                    <div class="bolt-row bolt-space-bottom-lg nw-form-control">
                        <div class="bolt-col-sm-12">
                            <bolt-checkbox
                                ngDefaultControl
                                required
                                formControlName="towingAuth"
                                id="towingAuth"
                                name="towingAuth"
                                [error]="towingAuthError"
                                (change)="onTowingAuthChange($event)">
                                I authorize the third party towing service arranged by Nationwide to move my vehicle.
                            </bolt-checkbox>
                        </div>
                    </div>
                }
            </form>
        }
    </div>

    <!-- Button Bar -->
    <bolt-button-bar layout="fixed">
        <bolt-button
            slot="cancel"
            (click)="onCancel()"
            [disabled]="isLoading"
            id="oysTrackerConfirm_cancelBtn">
            Cancel
        </bolt-button>
        <bolt-button
            slot="back"
            (click)="onBack()"
            [disabled]="isLoading">
            Back
        </bolt-button>
        <bolt-button
            slot="forward"
            arialabel="submit"
            type="solid"
            (click)="onSubmit()"
            [disabled]="isLoading"
            id="oysTrackerConfirm_submitBtn">
            Submit
        </bolt-button>
    </bolt-button-bar>
</main>
